import { SphereDropzone } from "@components/common/sphere-dropzone/sphere-dropzone";
import { isSingleFileUploadResponse } from "@custom-types/file-upload-type-guards";
import { UploadElementType } from "@custom-types/file-upload-types";
import { useCompanyId } from "@context-providers/company-id-provider";
import { useBrandingSettings } from "@hooks/use-branding-settings";
import { useState } from "react";

/** Renders the workspace logo settings */
export function WorkspaceLogoSetting(): JSX.Element {
  const companyId = useCompanyId();
  const { brandingSettings, onChangeBrandingSettings } = useBrandingSettings();
  const [isUploadingLogo, setIsUploadingLogo] = useState<boolean>(false);

  async function onUploadWorkspaceLogo(newImageUrl: string): Promise<void> {
    await onChangeBrandingSettings(newImageUrl, "url");

    setIsUploadingLogo(false);
  }

  async function removeWorkspaceLogo(): Promise<void> {
    await onChangeBrandingSettings("", "url");
  }

  return (
    <SphereDropzone
      existingImageUrl={brandingSettings.logo.url}
      isLoading={isUploadingLogo}
      setIsLoading={setIsUploadingLogo}
      onUploadComplete={(uploadedResponse) => {
        if (isSingleFileUploadResponse(uploadedResponse)) {
          void onUploadWorkspaceLogo(uploadedResponse);
        }
      }}
      onDeleteButtonClick={removeWorkspaceLogo}
      deleteIconTooltipText="Remove workspace logo"
      context={{
        companyId,
        uploadElementType: UploadElementType.default,
      }}
    />
  );
}
